import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Text } from "ui-components";
import { COLORS } from "ui-components/theme";
import { useSelector } from "react-redux";
import { makeSelectThemeColors } from "ducks/selectors/appSettings";
import { sanitizeHTML } from "utils/helpers";

const FieldError = ({ touched, error, values, sx }) => {
  const themeColors = useSelector(makeSelectThemeColors());
  return touched && error ? (
    <FormattedMessage html id={error} values={values}>
      {msg => (
        <Text
          fontWeight="500"
          className="field-error"
          mt={1}
          size="xs"
          color={themeColors?.error || COLORS.red[1]}
          sx={sx}
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(msg)
          }}
        />
      )}
    </FormattedMessage>
  ) : null;
};

FieldError.defaultProps = {
  values: {}
};

export default FieldError;
